import type { BubbleHeight, BubbleWidth, JimMood, JimVisual } from "./types";
import askJimHead from "./assets/ask-jim-head-icon-smiling-transparent.png";
import askJimHeadIdle from "./assets/head-states/ask-jim-head-idle.png";
import askJimHeadLaughing from "./assets/head-states/ask-jim-head-laughing.png";
import askJimHeadListening from "./assets/head-states/ask-jim-head-listening.png";
import askJimHeadLocked from "./assets/head-states/ask-jim-head-locked.png";
import askJimHeadSetup from "./assets/head-states/ask-jim-head-setup.png";
import askJimHeadSuccess from "./assets/head-states/ask-jim-head-success.png";
import askJimHeadThinking from "./assets/head-states/ask-jim-head-thinking.png";
import askJimHeadWarning from "./assets/head-states/ask-jim-head-warning.png";
import askJimIdea from "./assets/loaders/ask-jim-idea.gif";
import askJimThinking from "./assets/loaders/ask-jim-thinking.gif";
import bubbleCompactMedium from "./assets/loaders/speech-bubbles/speech-bubble-right-tail-compact-medium.png";
import bubbleCompactShort from "./assets/loaders/speech-bubbles/speech-bubble-right-tail-compact-short.png";
import bubbleCompactTall from "./assets/loaders/speech-bubbles/speech-bubble-right-tail-compact-tall.png";
import bubbleStandardMedium from "./assets/loaders/speech-bubbles/speech-bubble-right-tail-standard-medium.png";
import bubbleStandardShort from "./assets/loaders/speech-bubbles/speech-bubble-right-tail-standard-short.png";
import bubbleStandardTall from "./assets/loaders/speech-bubbles/speech-bubble-right-tail-standard-tall.png";
import bubbleWideMedium from "./assets/loaders/speech-bubbles/speech-bubble-right-tail-wide-medium.png";
import bubbleWideShort from "./assets/loaders/speech-bubbles/speech-bubble-right-tail-wide-short.png";
import bubbleWideTall from "./assets/loaders/speech-bubbles/speech-bubble-right-tail-wide-tall.png";

export const askJimPortrait = askJimHead;
export const askJimThinkingLoader = askJimThinking;
export const askJimIdeaLoader = askJimIdea;

export const bubbleAssets: Record<BubbleWidth, Record<BubbleHeight, string>> = {
  compact: {
    short: bubbleCompactShort,
    medium: bubbleCompactMedium,
    tall: bubbleCompactTall
  },
  standard: {
    short: bubbleStandardShort,
    medium: bubbleStandardMedium,
    tall: bubbleStandardTall
  },
  wide: {
    short: bubbleWideShort,
    medium: bubbleWideMedium,
    tall: bubbleWideTall
  }
};

export const jimHeadAssets: Record<JimMood, string> = {
  idle: askJimHeadIdle,
  listening: askJimHeadListening,
  thinking: askJimHeadThinking,
  success: askJimHeadSuccess,
  warning: askJimHeadWarning,
  locked: askJimHeadLocked,
  setup: askJimHeadSetup,
  laughing: askJimHeadLaughing
};

export const jimVisualAssets: Record<JimVisual, string> = {
  ...jimHeadAssets,
  thinkingGif: askJimThinking,
  ideaGif: askJimIdea
};
